import {
    Add,
    Archive,
    DeliveryDining,
    FoodBank,
    MoneyOffCsred,
    ShoppingCartCheckout,
    Inventory,
} from "@mui/icons-material";
import {
    Badge,
    SpeedDial,
    SpeedDialAction,
    SpeedDialIcon,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../AppContext";
import { isRoleAdmin, isRoleService } from "../frappeConfig";
import CashOutDialog from "../pages/PosPage/components/CashOutDialog/CashOutDialog";

const SimpleSpeedDialActions = ({
    handleTakeawayOrders,
    handleClosedOrders,
    handleClosePOSCash,
    notifications,
}) => {
    const navigate = useNavigate();
    const { userInfo, isTabsPos } = useContext(AppContext);

    const [closePOSDialogOpen, setClosePOSDialogOpen] = useState(false);

    const handleExpenseClaimClose = () => {
        setClosePOSDialogOpen(false);
    };

    const onConfirmExpenseClaim = () => {
        setClosePOSDialogOpen(false);
    };

    const speedDialActions = () => {
        if (isTabsPos) {
            return [
                {
                    label: "New Order",
                    icon: <Add />,
                    onClick: () => {
                        navigate("/pos/takeaway");
                    },
                },
                {
                    label: "Cash out",
                    icon: <ShoppingCartCheckout />,
                    onClick: () => {
                        setClosePOSDialogOpen(true);
                    },
                },
                {
                    label: "Closed Orders",
                    icon: <Archive />,
                    onClick: () => {
                        handleClosedOrders?.();
                    },
                },
                {
                    label: "Close POS Cash",
                    icon: <MoneyOffCsred />,
                    onClick: () => {
                        handleClosePOSCash?.();
                    },
                },
            ];
        } else if (isRoleService(userInfo.role_profile_name)) {
            return [
                {
                    label: "Takeaway Orders",
                    icon: <FoodBank />,
                    onClick: () => {
                        handleTakeawayOrders?.();
                    },
                },
            ];
        } else {

            const allowedActions = [];

            if(isRoleAdmin(userInfo.role_profile_name)) {
                allowedActions.push({
                    label: "Items",
                    icon: <Inventory />,
                    onClick: () => {
                        navigate("/items");
                    },
                });
            }

            allowedActions.push(...[
                
                {
                    label: "Takeaway Orders",
                    icon: <FoodBank />,
                    onClick: () => {
                        handleTakeawayOrders?.();
                    },
                },
                {
                    label: "Cash out",
                    icon: <ShoppingCartCheckout />,
                    onClick: () => {
                        setClosePOSDialogOpen(true);
                    },
                },
                {
                    label: "Closed Orders",
                    icon: <Archive />,
                    onClick: () => {
                        handleClosedOrders?.();
                    },
                },
                {
                    label: "Close POS Cash",
                    icon: <MoneyOffCsred />,
                    onClick: () => {
                        handleClosePOSCash?.();
                    },
                },
            ])
            return allowedActions;
        }
    };

    return (
        <React.Fragment>
            <SpeedDial
                icon={
                    <Badge
                        color="secondary"
                        badgeContent={notifications?.openingEntries}
                    >
                        <SpeedDialIcon />
                    </Badge>
                }
                ariaLabel="Speed Dial"
                sx={{
                    position: "absolute",
                    bottom: 15,
                    right: 15,
                    '& .MuiSpeedDial-actions': {
                        gap: '12px', // Increase spacing between actions
                    },
                    '& .MuiSpeedDialAction-staticTooltipLabel': {
                        whiteSpace: 'nowrap', // Prevent text wrapping
                        fontSize: '0.875rem',
                        fontWeight: 500,
                        // backgroundColor: 'rgba(97, 97, 97, 0.92)',
                        borderRadius: '4px',
                        padding: '2px 8px',
                    },
                }}
            >
                {speedDialActions().map((action) => (
                    <SpeedDialAction
                        key={"Speed_Dial_" + action.label}
                        icon={action.icon}
                        aria-label={action.label}
                        tooltipTitle={action.label}
                        tooltipOpen
                        onClick={action.onClick}
                        sx={{
                            margin: '4px 0', // Additional spacing between actions
                        }}
                    />
                ))}
            </SpeedDial>

            <CashOutDialog
                dialogOpen={closePOSDialogOpen}
                onCancel={handleExpenseClaimClose}
                onConfirm={onConfirmExpenseClaim}
                // selectedCustomer={selectedCustomer}
                // customerSelected={onCustomerSelected}
            ></CashOutDialog>
        </React.Fragment>
    );
};

export default SimpleSpeedDialActions;
